import { render, staticRenderFns } from "./mdbWeekView.vue?vue&type=template&id=12316f0e&scoped=true&"
import script from "./mdbWeekView.vue?vue&type=script&lang=js&"
export * from "./mdbWeekView.vue?vue&type=script&lang=js&"
import style0 from "./mdbWeekView.vue?vue&type=style&index=0&id=12316f0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12316f0e",
  null
  
)

export default component.exports